<template>
  <!-- <v-toolbar flat color="white" class="mb-3 pa-3"> -->
  <v-layout class="bg-white pa-3 pt-4 mb-3" row wrap>
    <v-flex xs12 sm6 md3>
      <v-text-field
        :label="$t('fields.search_text')"
        v-model="searchText"
      ></v-text-field>
    </v-flex>
    <v-flex xs12 sm6 md2 class="mx-3">
      <v-select
        :items="searchByitems"
        :label="$t('fields.search_by')"
        v-model="searchBy"
      ></v-select>
    </v-flex>
    <v-flex xs12 sm6 md4 class="mx-1 mt-3">
      <v-radio-group
        v-model="selectedStatus"
        @change="handleSearch(1)"
        row
        class="users-status pt-0"
      >
        <v-radio
          v-for="(item, index) in statusItems"
          :key="index"
          :label="item.text"
          :value="item.value"
        ></v-radio>
      </v-radio-group>
    </v-flex>

    <!-- <v-flex xs3 sm6 md1 class="mt-3"> </v-flex> -->

    <v-flex xs12 sm6 md2 class="align-center">
      <v-btn
        class="mt-5"
        color="primary"
        type="button"
        @click="handleSearch"
        :disabled="isDisabled"
        >{{ $t("button.search") }}</v-btn
      >
      <v-btn
        class="mx-2 mt-4"
        color="error"
        type="button"
        @click="handleClear"
        :disabled="isDisabled"
        >{{ $t("button.clear") }}</v-btn
      >
    </v-flex>
  </v-layout>
  <!-- </v-toolbar> -->
</template>

<script>
import { generateQuery } from "@/utils/helpers";
export default {
  watch: {
    "$route.query.page"(newValue) {
      if (this.page !== newValue) {
        this.page = newValue;
        this.handleSearch();
      }
    }
  },
  computed: {
    isDisabled() {
      if (this.searchText.length === 0 && this.selectedStatus.length === 0) {
        return true;
      }
      return false;
    }
  },
  data() {
    return {
      searchByitems: [
        {
          text: this.$t("fields.name"),
          value: "name"
        },
        {
          text: this.$t("fields.email"),
          value: "email"
        },
        {
          text: this.$t("fields.phone"),
          value: "phone"
        }
      ],
      statusItems: [
        // {
        //   text: this.$t("fields.all"),
        //   value: ""
        // },
        {
          text: this.$t("fields.active"),
          value: "active"
        },
        {
          text: this.$t("fields.blocked"),
          value: "blocked"
        },
        {
          text: this.$t("fields.admin"),
          value: "admins"
        }
      ],

      searchBy: "name",
      searchText: "",

      selectedStatus: "",

      adminToggle: false,

      page: 1,
      clear: false,
      queryObj: { page: 1 },
      queryUrl: ""
    };
  },
  mounted() {
    this.setQueryValues();
  },
  methods: {
    handleSearch(page) {
      let queryObj = this.generateQueryObject();
      let queryString = generateQuery(queryObj); // String
      let newRouterQuery = {};
      if (this.clear) {
        newRouterQuery = { ...queryObj };
        this.clear = false;
      } else {
        newRouterQuery = { ...this.$route.query, ...queryObj };
        this.clear = false;
      }

      if (page) {
        newRouterQuery.page = page;
      }

      this.$emit("queryChanged", queryString);

      this.$router.replace({ query: newRouterQuery });
    },

    handleClear() {
      this.searchText = "";
      this.searchBy = "name";
      this.selectedStatus = "";
      this.adminToggle = false;
      this.clear = true;
      this.page = 1;
      this.handleSearch();
    },

    generateQueryObject() {
      let queryObj = {};
      queryObj.page = this.page;
      if (this.selectedStatus.length > 0) {
        queryObj.q = this.selectedStatus;
      }
      if (this.searchText.length > 0) {
        queryObj[this.searchBy] = this.searchText;
      }
      return queryObj;
    },

    setQueryValues() {
      const routerQuery = this.$route.query;
      Object.keys(routerQuery).forEach(key => {
        if (routerQuery[key] === "q") {
          this.selectedStatus = routerQuery[key];
        } else if (key !== "page" && key !== "q") {
          this.searchBy = key;
          this.searchText = routerQuery[key];
        }
      });
    }
  }
};
</script>

<style>
.users-status {
  /* margin-top: 13px; */
}
</style>
